import { render, staticRenderFns } from "./SmartTableRegistrations.vue?vue&type=template&id=eb89bca4&"
import script from "./SmartTableRegistrations.js?vue&type=script&lang=js&"
export * from "./SmartTableRegistrations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports